import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface IDefaultData {
    alertsDrawerOpen: boolean
    accountDrawerOpen: boolean
    mobileDrawerOpen: boolean
}
interface IUseGlobalDrawers extends IDefaultData {
    toggleAlertsDrawer: (open: boolean) => void
    toggleAccountDrawer: (open: boolean) => void
    toggleMobileDrawer: (open: boolean) => void
    resetDrawers: () => void
}

const defaultData: IDefaultData = {
    alertsDrawerOpen: false,
    accountDrawerOpen: false,
    mobileDrawerOpen: false
}

export const useGlobalDrawers = create<IUseGlobalDrawers>()(
    devtools(
        (set) => ({
            ...defaultData,
            toggleAlertsDrawer: (open) => set({ alertsDrawerOpen: open }),
            toggleAccountDrawer: (open) => set({ accountDrawerOpen: open }),
            toggleMobileDrawer: (open) => set({ mobileDrawerOpen: open }),
            resetDrawers: () => set(defaultData)
        }),
        { name: `useGlobalDrawers` }
    )
)
